module.exports = __webpack_public_path__ + "img/icon-car.d9b2a59e.svg";